// Prepend all the strings with dev- to avoid collision with the real routes.
import { html } from 'lit';

export const DevRoutes = {
  Home: 'dev-home',
  FancyTableDemo: 'fancy-table-demo',
  SkiaSpeedTest: 'skia-speed-test',
  WizardDemo: 'wizard-demo',
  HealthCheckDemo: 'health-check-demo',
  MigrateDemo: 'migrate-demo',
  PushTool: 'push-tool'
};

export const devRoutes = {
  [DevRoutes.Home]: {
    route: '/dev',
    view: () => import('./components/views/dev-home.js'),
    title: 'Dev Home',
    render: () => html`<dev-home></dev-home>`
  },
  [DevRoutes.SkiaSpeedTest]: {
    route: '/dev/skia-speed-test',
    view: () => import('./components/views/skia-speed-test.js'),
    title: 'Skia Speed Test',
    render: () => html`<skia-speed-test></skia-speed-test>`
  },
  [DevRoutes.FancyTableDemo]: {
    route: '/dev/fancy-table',
    view: () => import('./components/views/fancy-table-demo.js'),
    title: 'Fancy Table Demo',
    render: () => html`<fancy-table-demo></fancy-table-demo>`
  },
  [DevRoutes.WizardDemo]: {
    route: '/dev/wizard-demo',
    view: () => import('./components/views/wizard-demo/wizard-demo.js'),
    title: 'Wizard Demo',
    render: () => html`<wizard-demo></wizard-demo>`
  },
  [DevRoutes.HealthCheckDemo]: {
    route: '/dev/health-check-demo',
    view: () => import('./components/views/health-check-demo/health-check-demo.js'),
    title: 'Health Check Demo',
    render: () => html`<health-check-demo></health-check-demo>`
  },
  [DevRoutes.MigrateDemo]: {
    route: '/dev/migrate-demo',
    view: () => import('./components/views/migrate-demo/migrate-demo.js'),
    title: 'Migrate Demo',
    render: () => html`<migrate-demo></migrate-demo>`
  },
  [DevRoutes.PushTool]: {
    route: '/dev/push',
    view: () => import('./components/views/push-tool-view.js'),
    title: 'Push Notifications Tool',
    render: () => html`<push-tool-view></push-tool-view>`
  }
};